import * as React from 'react'
import Select from 'react-select'
import { getLanguages } from './countryData'

interface LanguageSelectProps {
	id?: string
	language: string
	languageChanged: (newLanguage: string) => void
}

const customStylesForSelect = {
	container: (provided: any) => ({
		...provided,
		width: '100%',
	}),
}

const LanguageSelect: React.SFC<LanguageSelectProps> = (props) => {
	return (
		<div data-testid="languageSelect">
			<Select
				classNamePrefix='language-select'
				styles={customStylesForSelect}
				placeholder="Select a language"
				menuPlacement="auto"
				inputId={props.id}
				value={getLanguages()
					.map((item) => {
						return {
							label: item.name,
							value: item.code,
						}
					})
					.find((language) => {
						return language.value === props.language
					})}
				options={getLanguages().map((item) => {
					return {
						label: item.name,
						value: item.code,
					}
				})}
				onChange={(value: any) => {
					if (value) {
						props.languageChanged(value.value)
					} else {
						props.languageChanged('')
					}
				}}
			/>
		</div>
	)
}

export default LanguageSelect
